import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'discountSeparador'
})
export class DiscountSeparadorPipe implements PipeTransform {

  transform(value:string): string {
    if (value != "") {
      let espaciosBlancos:string = value.trim();
      let separador:string[] = espaciosBlancos.split("-");
      if (espaciosBlancos != null && espaciosBlancos != "") {
        for (let i = 0; i < separador.length; i++) {
          separador[i] + ",";
        }
        return separador[1];
      }else {
        return "";
      }
    }
  }

}
